export const languageList = {
  sv: "Svenska",
  no: "Norsk",
  fi: "Finnish",
  da: "Dansk",
  es: "Español",
  de: "Deutsch",
  it: "Italiano",
  en: "English",
};

const languages = [
  { value: "da", text: "Dansk" },
  { value: "de", text: "Deutsch" },
  { value: "en", text: "English" },
  { value: "es", text: "Español" },
  { value: "fi", text: "Finnish" },
  { value: "it", text: "Italiano" },
  { value: "no", text: "Norsk" },
  { value: "sv", text: "Svenska" },
];

export const languagesMinimal = [
  { value: "sv", label: "Svenska" },
  { value: "en", label: "English" },
  { value: "fi", label: "Finnish" },
  { value: "no", label: "Norsk" },
  { value: "da", label: "Dansk" },
  { value: "de", label: "Deutsch" },
  { value: "es", label: "Español" },
];

export const storeLanguages = ["sv", "en", "fi"];
export const storefrontLanguagePreset = ["sv", "en", "no", "fi", "da", "de", "es"];

export default languages;
